module.exports = __webpack_public_path__ + "img/hr-tree-07-g-leaves.01a5a08a.png";